import "./Custom/CustomApplicationConfiguration";
import { main } from "@configuratorware/configurator-frontendgui/App";
import { render } from "./Custom/App";
import "./index.scss";

main();

render();
